module.exports = __webpack_public_path__ + "img/15.33e4d103.png";